import React from 'react'
import { Link } from 'react-router-dom'
import { t } from '../i18n'
import { track } from '../Utils/analytics'
import { articleOpened } from '../Utils/article'
import { timeAgo } from '../Utils/time'
import { CommentButton, LastComment } from './Comments'
import { ChevronRight } from './Icons'
import ShareButton from './ShareButton'
import { SourceAvatar, SourceStack } from './SourceAvatar'
import TopicTag from './TopicTag'

/* Source, time, NOVO and U RAZVOJU (spec 5.2, item 2), across the full
   width of the card, wrapping when it doesn't fit. */
export function CardMeta({ story, isNew, from }) {
  return (
    <div className="card-meta">
      <SourceAvatar source={story.source} size={20} />
      <Link
        to={`/izvor/${story.source.slug}`}
        className="card-source"
        onClick={() => track('source_open', { from, source: story.source.slug })}
      >
        {story.source.name}
      </Link>
      <span className="card-dot" aria-hidden="true">
        ·
      </span>
      <time dateTime={story.publishedAt}>{timeAgo(story.publishedAt)}</time>
      {isNew && <span className="badge-new">{t('card.new')}</span>}
      {story.isDeveloping && (
        <span className="badge-developing">
          <span className="dev-dot" aria-hidden="true" />
          {t('card.developing')}
        </span>
      )}
    </div>
  )
}

/* The headline links to the portal's article in a new tab (spec 5.2). */
export function ArticleLink({ story, from, className, children, tabIndex, ariaHidden }) {
  return (
    <a
      href={story.url}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      tabIndex={tabIndex}
      aria-hidden={ariaHidden}
      onClick={() => articleOpened({ articleId: story.articleId, source: story.source, from })}
    >
      {children}
    </a>
  )
}

export function SourcesButton({ story, from }) {
  if (story.sourceCount < 2) return <span />
  return (
    <Link
      to={`/prica/${story.id}`}
      className="sources-button"
      aria-label={`${t('card.sources', { count: story.sourceCount })}: ${t('card.openStory')}`}
      onClick={() => track('story_open', { source: 'card', from })}
    >
      <SourceStack sources={story.sourcePreview} size={20} />
      <span>{t('card.sources', { count: story.sourceCount })}</span>
      <ChevronRight size={16} strokeWidth={2.5} />
    </Link>
  )
}

/* A story in a feed (spec 5.2). No pictures: news images belong to agencies
   and photographers (spec 1a), so the source's logo, the topic and the type
   carry the card. */
export default function StoryCard({ story, isNew = false, from = 'feed', hideTopic = null }) {
  return (
    <article className="story-card">
      {/* A topic page doesn't tag its own stories with itself. */}
      <TopicTag topic={story.topic?.slug === hideTopic ? null : story.topic} />
      <CardMeta story={story} isNew={isNew} from={from} />
      <h2 className="card-title">
        <ArticleLink story={story} from={from}>
          {story.title}
        </ArticleLink>
      </h2>
      <LastComment story={story} from={from} />
      <div className="card-footer">
        <SourcesButton story={story} from={from} />
        <div className="card-actions">
          <CommentButton story={story} from={from} />
          <ShareButton story={story} from={from} />
        </div>
      </div>
    </article>
  )
}
